import {
  Card,
  CardContent,
  Typography,
  Chip,
  Checkbox,
  Box,
  Tooltip,
  IconButton,
  CardActions,
} from '@mui/material'
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined'
import moment from 'moment'
import Link from '@mui/material/Link'
import { unlinkInternalTicketFromFrontConversation } from '../../api'

export const TicketCard = ({
  ticket,
  isChecked,
  handleCheckboxChange,
  linkedTicketsMode,
  frontTicketId,
  setLinkedInternalTickets,
  isLastCard,
}) => {
  const handleOnUnlinkClick = async () => {
    await unlinkInternalTicketFromFrontConversation({
      internalTicketId: ticket.id,
      conversationId: frontTicketId,
    })

    setLinkedInternalTickets((prevLinkedTickets) =>
      prevLinkedTickets.filter((linkedTicket) => linkedTicket.id !== ticket.id)
    )
  }

  const formattedDate = moment(ticket.createdAt).locale('fr').format('LL')

  return (
    <Card
      variant="outlined"
      sx={{
        width: '100%',
        maxWidth: '400px',
        marginBottom: isLastCard ? '70px' : undefined,
        boxSizing: 'border-box',
        backgroundColor: 'white',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {!linkedTicketsMode && (
          <CardActions sx={{ padding: 0 }}>
            <IconButton aria-label="checkbox">
              <Checkbox
                checked={isChecked}
                onChange={() => handleCheckboxChange(ticket.id)}
              />
            </IconButton>
          </CardActions>
        )}

        <CardContent sx={{ flex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              mb: 1,
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            <Tooltip title={ticket.processName} placement="top">
              <Chip
                label={
                  ticket.processName.length > 21
                    ? ticket.processName.substring(0, 21) + '...'
                    : ticket.processName
                }
                variant="outlined"
                sx={{
                  borderColor: '#FFA500',
                  color: '#FFA500',
                }}
              />
            </Tooltip>

            {ticket.stateName ? (
              <Tooltip title={ticket.stateName} placement="top">
                <Chip
                  label={
                    ticket.stateName.length > 15
                      ? ticket.stateName.substring(0, 15) + '...'
                      : ticket.stateName
                  }
                  sx={{
                    backgroundColor: '#42a5f5',
                    color: 'white',
                  }}
                />
              </Tooltip>
            ) : (
              <Chip label="Pré-ticket" color="secondary" />
            )}
          </Box>

          <Typography variant="body1">
            {ticket?.reference ? (
              <Link
                color="#2294f2"
                target="_blank"
                href={`https://syndic.manda.fr/tickets?displayedFilters=%7B%7D&filter=%7B%22q%22%3A%22${ticket.reference}%22%7D&order=DESC&page=1&perPage=50&sort=reference`}
              >
                {ticket.reference}
              </Link>
            ) : (
              <Link
                color="#2294f2"
                target="_blank"
                href={`https://syndic.manda.fr/tickets_drafts?displayedFilters=%7B%7D&filter=%7B%22q%22%3A%22${ticket.id}%22%7D&order=DESC&page=1&perPage=50&sort=reference`}
              >
                {ticket.id}
              </Link>
            )}
          </Typography>

          {ticket.mondayCoproCode.length > 25 ? (
            <Tooltip title={ticket.mondayCoproCode} placement="bottom">
              <Typography variant="body1" sx={{ color: 'primary' }}>
                {ticket.mondayCoproCode.substring(0, 25) + '...'}
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="body1" sx={{ color: 'primary' }}>
              {ticket.mondayCoproCode}
            </Typography>
          )}

          {ticket?.title && ticket?.title.length > 30 ? (
            <Tooltip title={ticket.title} placement="bottom">
              <Typography variant="body2" color="primary">
                {ticket.title.substring(0, 30) + '...'}
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="body2" color="primary">
              {ticket.title}
            </Typography>
          )}

          <Typography variant="body2" color="textSecondary">
            Créé le {formattedDate}
          </Typography>
        </CardContent>

        {linkedTicketsMode && (
          <CardActions sx={{ padding: 0 }}>
            <IconButton aria-label="unlink" onClick={handleOnUnlinkClick}>
              <LinkOffOutlinedIcon />
            </IconButton>
          </CardActions>
        )}
      </Box>
    </Card>
  )
}
